// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Periode CI98
export default class CiPeriod  {
  // Identifiant unique
  public id: number;
  // Début
  public debut: Date;
  // Fin
  public fin: Date;
  // Libellé
  public label: string;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.debut = new Date(1901,1,1,0,0,0,0);
    this.fin = new Date(1901,1,1,0,0,0,0);
    this.label = '';
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: CiPeriod): CiPeriod {
    const newCiPeriod: CiPeriod = new CiPeriod();
    newCiPeriod.id = obj.id;
    newCiPeriod.debut = new Date(obj.debut);
    newCiPeriod.fin = new Date(obj.fin);
    newCiPeriod.label = obj.label;
    newCiPeriod.canUpdate = obj.canUpdate;
    newCiPeriod.canDelete = obj.canDelete;
    newCiPeriod.display = obj.display;
    newCiPeriod.notifDefType = obj.notifDefType;
    return newCiPeriod;
  }

  public toJsonCiPeriod (): string {
    const json = {
      debut: this.debut ? new Date (this.debut).toString() : this.debut,
      fin: this.fin ? new Date (this.fin).toString() : this.fin,
      label: this.label,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromCiPeriod (obj: CiPeriod): void {
    this.id = obj.id;
    this.debut = new Date(obj.debut);
    this.fin = new Date(obj.fin);
    this.label = obj.label;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareCiPeriod (value: CiPeriod): boolean {
    return (this.toJsonCiPeriod() == value.toJsonCiPeriod());
  }

  public cloneCiPeriod (): CiPeriod {
    return CiPeriod.fromJson(this);
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/ciperiods/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(ciPeriods: CiPeriod[]) {
    ciPeriods.forEach((item) => {
      item.debut = item.debut ? new Date(item.debut) : item.debut;
      item.fin = item.fin ? new Date(item.fin) : item.fin;
    })
  }
}
